import { AnalyticsService } from '../../../../services/analytics'
import { IWindow } from '../../../../services/analytics/adapters/mparticle'
import { Utils } from '../../../../utils/common'
import { logger } from '../../../../utils/common/logger'
import { ErrorFormatter } from './formatters/error'

declare let window: IWindow

const ERR_MSG = 'Empty object is not acceptable'

export class PageEvents {

    /**
     * Custom event types
     * https://docs.mparticle.com/developers/sdk/web/event-tracking/#custom-event-type
     */

    public static mpEventType: { [key: string]: number } = {
        Location: 2,
        Navigation: 1,
        Other: 8,
        Search: 3,
        Social: 7,
        Transaction: 4,
        Unknown: 0,
        UserContent: 5,
        UserPreference: 6,
    }

    /**
     * Custome event names
     */

    public static mpEventName = {
        Default: 'Unknown',
        ScreenView: 'screen_view'
    }

    public static mpSupportedNativeAction=[
        AnalyticsService.ACTION_PAGE_LOAD
    ]

    public errorFormatter = new ErrorFormatter()

    /**
     * Implement mParticle's logPageView - https://docs.mparticle.com/developers/sdk/web/screen-tracking/
     * @param: string, object, object
     * @returns: boolean
     */

    public logPageView(EventType: string, properties: object, customFlag?: object): boolean {
        try {
            if (Utils.isEmptyObject(properties)) {
                this.logCustomError(ERR_MSG, 'logPageView')
                return false
            }
            const args = [EventType, properties, customFlag]
            window.mParticle.ready(function() {
                window.mParticle.logPageView.apply(this, args)
            })
            return true
        } catch (e) {
            logger('error', 'Unable to log mParticle page view event ', e)
            return false
        }
    }

    /**
     * Implement mParticle's logEvent - https://docs.mparticle.com/developers/sdk/web/event-tracking/
     * @param: string, number, object, object
     * @returns: boolean
     */

    public logEvent(EventName: string, EventType: number, properties: object, customFlag?: object): boolean {
        try {
            if (Utils.isEmptyObject(properties)) {
                this.logCustomError(ERR_MSG, 'logEvent')
                return false
            }
            const args = [EventName, EventType, properties, customFlag]
            window.mParticle.ready(function() {
                window.mParticle.logEvent.apply(this, args)
            })
            return true
        } catch (e) {
            logger('error', 'Unable to log mParticle custom event ', e)
            return false
        }
    }

    /**
     * Implement mParticle's upload -
     * https://docs.mparticle.com/developers/sdk/web/core-apidocs/classes/
     * mParticle%20&%20mParticleInstance.html#method_upload
     * @returns: {void}
     */
    public upload(): void {
        try {
            window.mParticle.ready(() => window.mParticle.upload())
        } catch (e) {
            console.error(`PageEvents.upload error`, e)
        }
    }

    /**
     * Custom log event to log errors into mParticle
     * https://docs.mparticle.com/developers/sdk/web/event-tracking/
     */
    public logCustomError(error: string, eventName: string): void {
        const errorMessage = this.errorFormatter.error(error, eventName)
        this.logEvent(PageEvents.mpEventName.Default, PageEvents.mpEventType.Unknown, errorMessage)
    }
}
